export function getCompensationRateLabel(basePayType?: string | null) {
  return basePayType === "Weekly" ? "Rate (per week)" : "Rate (per hour)";
}

export function getCompensationRateFrequency(basePayType?: string | null) {
  return basePayType === "Weekly" ? "weekly" : "hourly";
}
